import {Typography} from "@bezlimit/bezlimit-ui";

export default function Loading() {
    return (
        <Typography as="div" className="preloader-wrapper">
            <Typography as="div" className="preloader"></Typography>
        </Typography>
    );
}
